import React from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import { getSeoForPath } from "./seoConfig";

export default function SeoRouter() {
  const location = useLocation();
  const seo = getSeoForPath(location.pathname);

  return (
    <Seo
      title={seo.title}
      description={seo.description}
      keywords={seo.keywords}
      path={location.pathname}
    />
  );
}

